module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","taxonomy.label":"Taxonomy","labelSearch":"Search","refresh":"Refresh","delete":"Delete","actions":"Actions"},"de":{"labelI18n.en":"Label(En)","labelI18n.de":"Label(De)","taxonomy.label":"Taxonomy","labelSearch":"Suchen","refresh":"Refresh","delete":"Löschen","actions":"Actionen"}}')
  delete Component.options._Ctor
}
